import { REQUEST, FAILURE, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

export const GET_USER_TAG_LOGS = createRequestTypes('GET_USER_TAG_LOGS');
export const getUserTagLogs = {
  // Keep the same payload shape used by PaginationTable and the other list pages.
  request: search => action(GET_USER_TAG_LOGS[REQUEST], search),
  success: data => action(GET_USER_TAG_LOGS[SUCCESS], { data }),
  failure: error => action(GET_USER_TAG_LOGS[FAILURE], { error }),
};

export const GET_USER_TAG_LOG_FILTERS = createRequestTypes('GET_USER_TAG_LOG_FILTERS');
export const getUserTagLogFilters = {
  request: () => action(GET_USER_TAG_LOG_FILTERS[REQUEST]),
  success: data => action(GET_USER_TAG_LOG_FILTERS[SUCCESS], { data }),
  failure: error => action(GET_USER_TAG_LOG_FILTERS[FAILURE], { error }),
};

export const EXPORT_USER_TAG_LOGS = createRequestTypes('EXPORT_USER_TAG_LOGS');
export const exportUserTagLogs = {
  request: search => action(EXPORT_USER_TAG_LOGS[REQUEST], { search }),
  success: data => action(EXPORT_USER_TAG_LOGS[SUCCESS], { data }),
  failure: error => action(EXPORT_USER_TAG_LOGS[FAILURE], { error }),
};
